<template>
  <div>
    <ListCard
        :items="toolBtns"
        @onClick="openCreateModal"
    />

    <section class="campaing_filters my_14">
        <div class="campaing_filter">
            <SearchInput
                :placeholder="$t('CAMPAIGN.EVALUATIONS.FILTERS.SEARCH_PLACEHOLDER')"
                v-model="searchValue"
                @search="onSearch"
            />
        </div>
        <div class="campaing_filter filters__button-wrap">
            <div v-if="appliedFilters.length" class="filters__applied-indicator" />
            <woot-button
                class="margin-right-small clear"
                color-scheme="secondary"
                data-testid="create-new-contact"
                icon="filter"
                @click="onToggleFilter"
                >
                {{ $t('CONTACTS_PAGE.FILTER_CONTACTS') }}
            </woot-button>
        </div>
    </section>

    <ToolsTable
        :cols="cols"
        :records="records"
        :isLoading="uiFlags.isFetching"
        :sort-config="sortConfig"
        @on-sort-change="onSortChange"
        @on-edit-click="openEditPopup"
        @on-delete-click="openDeletePopup"
        @on-duplicate-click="onDuplicate"
    />

    <div class="loadMore_btn">
        <woot-button
        variant="clear"
        size="small"
        color-scheme="primary"
        :is-loading="uiFlags.isFetching"
        @click="onPageChange(Number(meta.current_page)+1)"
        :is-disabled="paginationCompute.isLastPage"
        >
        {{paginationCompute.btnText}}
        </woot-button>
    </div>
    <woot-modal
        :show.sync="showFiltersModal"
        :on-close="onToggleFilter"
        size="medium"
    >
        <ToolsAdvancedFilter
          v-if="showFiltersModal"
          :on-close="onToggleFilter"
          :filterItems="filterItems"
          :initialAppliedfilters="appliedFilters"
          :filterAttributes="filterAttributes"
          @applyFilter="onApplyFilter"
          @clearFilters="clearFilters"
        />
    </woot-modal>

    <div v-if="isAddToolModalOpen">
        <AddToolModal
        :isOpen="isAddToolModalOpen"
        :onClose="closeAddToolModal"
        :tool="editRow"
        :agentVariables="llmContactAttributes"
        :isDuplicateCreate="isDuplicateCreate"
        :toolType="createToolType"
        @onAdd="onAddTool"
        @onUpdate="onUpdateTool"
        />
    </div>
    <div v-if="isSystemToolModalOpen">
      <SystemToolSettingModal
        :isOpen="isSystemToolModalOpen"
        @onClose="closeSystemToolModal"
        :system_tool="editRow"
        :agent_list="llm_bots"
        :isSubmitting="uiFlags.isCreating || uiFlags.isUpdating"
        @onSubmit="onSubmitSystemTool"
      />
    </div>

    <DeleteModal
        :show="!!deleteRow"
        :title="$t('COUPON.DELETE_MODAL.TITLE')"
        :onConfirm="onConfirmDelete"
        :onClose="onCloseDeleteModal"
        :confirmText="$t('COUPON.DELETE_MODAL.CONFIRM_BTN')"
        :rejectText="$t('COUPON.DELETE_MODAL.REJECT_BTN')"
    />
  </div>
</template>

<script>
import ListCard from "./ListCard.vue"
import ToolsTable from "./ToolsTable.vue"
import ToolsAdvancedFilter from "./ToolsAdvancedFilter.vue"
import { mapGetters } from 'vuex';
import SearchInput from 'dashboard/components/ui/SearchInput.vue'
import alertMixin from 'shared/mixins/alertMixin';
import helperMixin from 'shared/mixins/helperMixin';
import {toolFilterTypes,FilterAttributList,TOOL_KIND_STRING, SYSTEM_TOOL_IDS} from "../ai.constant"
import AddToolModal from "../../settings/campaigns/llm_chatbot/AddToolModal.vue"
import DeleteModal from "components/widgets/modal/DeleteModal.vue"
import SystemToolSettingModal from "./SystemToolSettingModal.vue"
import ToolAPI from "../../../../api/tools"

export default {
    components:{
        ListCard,
        ToolsTable,
        SearchInput,
        ToolsAdvancedFilter,
        AddToolModal,
        DeleteModal,
        SystemToolSettingModal,
    },
    mixins:[helperMixin,alertMixin],
    data(){
        return {
            // add/edit
            createToolType: "webhook",
            toolBtns:[
                {id:"webhook",title:"Add webhook tool", icon:"document-checkmark"},
                {id:"client",title:"Add client tool", icon:"wrench"},
            ],
            isAddToolModalOpen: false,
            isSystemToolModalOpen: false,
            editRow:{},
            isDuplicateCreate: false,
            deleteRow: null,


            // table and filter
            searchValue:'',
            sortConfig: { name: 'asc' },
            showFiltersModal: false,
            filterItems: toolFilterTypes.map(filter => ({
                ...filter,
                attributeName: this.$t(
                `${filter.attributeI18nKey}`
                ),
            })),
            appliedFilters:[],
            cols :[
                { key: 'name', name: 'Name', visible: true, type: 'default' },
                { key: 'kind', name: 'Kind', visible: true, type: 'default' },
                { key: 'created_at', name: 'created_at', visible: true, type: 'default' },
                { key: 'description', name: 'Description', visible: true, type: 'default' },
                { key: 'action', name: 'action', visible: true, type: 'default' },
            ],
        }
    },
    computed:{
       ...mapGetters({
            uiFlags: "tools/getUIFlags",
            meta: "tools/getMeta",
            records: "tools/getTools",
            llm_bots: 'llmbots/getLLMBots',
            llmContactAttributes: 'attributes/getLLMcontactAttributes',
        }),
        paginationCompute(){
            const totalPages = Math.ceil(this.meta.count / this.meta.page_size);
            const isLastPage = this.meta.current_page >= totalPages;
            const currentCount = Math.min(this.meta.current_page * this.meta.page_size, this.meta.count);
            // const btnText = `Load More Orders (${currentCount}/${this.meta.count})`;
            const btnText = `${this.$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.LOAD_MORE_BTN')} (${currentCount}/${this.meta.count})`;

            return{
                isLastPage,
                btnText,
            }
        },
        filterAttributes(){
            return FilterAttributList.map(el=>({...el,name:this.$t(el.name)}))
        },
    },
    mounted(){
        this.fetchRecordList({page:1})
        this.$store.dispatch('llmbots/fetchLLMBots');
        this.$store.dispatch('attributes/fetchLlmContactAttributes');
    },
    methods:{
        fetchRecordList(query={}){
            try {
                const defautQuery = {
                    page: this.meta.current_page,
                    page_size:  this.meta.page_size,
                    q: this.searchValue,
                    payload: this.appliedFilters,
                    sort: this.getSortAttribute(this.sortConfig),
                    ...query,
                }
                // prepare filter payload
                defautQuery.payload = defautQuery.payload.map(el=>{
                    const temp = {...el}
                    if (el.attribute_key === 'type') {
                        temp.values = [el.values.id];
                        return temp
                    }
                    temp.values = [el.values];
                    return temp;
                })

                if (defautQuery.payload?.length) {
                    this.$store.dispatch("tools/filterTools",this.cleanObject(defautQuery));
                }else{
                    delete defautQuery.payload;
                    this.$store.dispatch("tools/fetchTools",this.cleanObject(defautQuery));
                }
            } catch (error) {
                console.log(error);
            }
        },
         onPageChange(page){
            this.fetchRecordList({page,})
        },
        onSearch(value){
            this.fetchRecordList({q:value,page:1});
        },
        getSortAttribute(newSort={}) {
            let sortAttr = Object.keys({...this.sortConfig,...newSort}).reduce((acc, sortKey) => {
                const sortOrder = this.sortConfig[sortKey];
                if (sortOrder) {
                const sortOrderSign = sortOrder === 'asc' ? '' : '-';
                return `${sortOrderSign}${sortKey}`;
                }
                return acc;
            }, '');
            if (!sortAttr) {
                this.sortConfig = { name: 'asc' };
                sortAttr = 'name';
            }
            return sortAttr;
        },
        onSortChange(params) {
            console.log(params);
            let sortDetails = {};
            Object.keys(params).forEach(function(key) {
                if (params[key] !== '') {
                    sortDetails = {};
                    sortDetails.key = key;
                    sortDetails.order = params[key];
                }
            });
            this.sortConfig = params;
            const sort = this.getSortAttribute(sortDetails)
            this.fetchRecordList({sort,page:1});
        },
        onToggleFilter() {
            this.showFiltersModal = !this.showFiltersModal;
        },
         onApplyFilter(filters) {
            this.appliedFilters = filters;
            console.log(filters);
            // if payload has kind then convert to array  of id
            // transform to payload also append to appliedFielters so that pagination also use same
            this.fetchRecordList({payload:filters,page:1});
            this.onToggleFilter()
        },
        clearFilters() {
            console.log(this.filterItems);
            this.appliedFilters = [];
            this.fetchRecordList({payload:[],page:1});
        },
        onDuplicate(row){
            // set duplicate true
            this.isDuplicateCreate = true;
            this.openEditPopup(row);
        },
        async openEditPopup(row){
            // get the tools details by id, and open the modal
            // const {data} = await ToolaAPI.fetchToolById(row.id)
            // console.log(data);
            this.editRow = row;
            if (row.kind === TOOL_KIND_STRING.PRECONFIGURE) {
                const existTool = await this.getToolById(row.id)
                // const pefonfRowDemo = {
                //     id: SYSTEM_TOOL_IDS.TRANSFER_TO_AGENT,
                //     name: SYSTEM_TOOL_IDS.TRANSFER_TO_AGENT,
                //     description: "",
                //     rules:[],
                // }
                this.editRow = {
                    ...existTool,
                    id: this.isDuplicateCreate ? null : existTool.id,
                    name: this.isDuplicateCreate ? existTool.name + "(1)" : existTool.name,
                    rules: existTool.rules.map(el=>{
                        const agent = this.llm_bots.find(agentEl=>agentEl.id == el.agent_id)
                        return {
                            ...el,
                            agent_id: agent,
                        };
                    })
                };
                console.log("open preconf");
                this.openSystemToolModal(true);
                return
            }
            const toolBtn = this.toolBtns.find(el=>el.id === row.kind);
            console.log(row,this.toolBtns);
            if (toolBtn) {
                this.openCreateModal(toolBtn);
            }
        },
        openSystemToolModal(){
            this.isSystemToolModalOpen = true;
        },
        closeSystemToolModal(){
            this.isSystemToolModalOpen = false;
        },
        async onSubmitSystemTool(item){
            try {
                const systemTool = {
                    ...item,
                    id:item.id,
                    kind: TOOL_KIND_STRING.PRECONFIGURE,
                    name: item.name,
                    description: item.description,
                    rules: item.rules.map(ruleEl=>({
                        agent_id:ruleEl.agent_id.id,
                        condition:ruleEl.condition
                    }))
                }
                const resData = await this.onUpdateTool(systemTool);
                this.closeSystemToolModal();
                this.closeAddToolModal();
            } catch (error) {
                console.log(error);
                this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
            }
        },

        // add/ edit/ duplicatie
        openCreateModal(toolBtn){
            this.createToolType = toolBtn?.id;
            console.log(this.createToolType);
            this.openAddToolModal();
        },
        onAddTool(tool){
            console.log(tool,"Add tool");
            const payload = tool;
            this.$store.dispatch("tools/createTool",payload)
        },
        async onUpdateTool(tool){
            if (this.isDuplicateCreate) {
                const {id,...toolPayload} = tool;
                this.onAddTool(toolPayload)
            }else{
                console.log(tool,"update")
                return await this.$store.dispatch("tools/updateToolById",{tool_id:tool.id,payload:tool});
            }
        },
        openAddToolModal(){
            this.isAddToolModalOpen = true;
        },
        closeAddToolModal(){
            this.isAddToolModalOpen = false;
            this.isDuplicateCreate = false;
            this.editRow = {};
        },
        async openDeletePopup(row){
            this.deleteRow = row;
        },
        onCloseDeleteModal(){
            this.deleteRow = null;
        },
        async onConfirmDelete(){
            try {
                // open confirm popup
                await this.$store.dispatch("tools/deleteToolById",{tool_id:this.deleteRow?.id});
                this.onCloseDeleteModal();
                this.showAlert(this.$t('CAMPAIGN.EVALUATIONS.ADD.BTNS.SUCCESS_MSG_DELETE'));
            } catch (error) {
                console.log(error);
                 this.showErrAlert(error,"Something went wrong!")
            }
        },
        async getToolById(tool_id){
            try {
                console.log({tool_id});
                const {data:exTool} = await ToolAPI.fetchToolById(tool_id);
                console.log(exTool,"ex tool");
                return exTool;
            } catch (error) {
                console.log(error);
            }
        },

    },
}
</script>


<style scoped lang="scss">
.loadMore_btn button{
  display: block;
  margin: auto;
}
.campaing_filters{
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  .campaing_filter{
    p{
      margin-bottom: 8px;
    }
  }
}


.filters__button-wrap {
  position: relative;

  .filters__applied-indicator {
    position: absolute;
    height: var(--space-small);
    width: var(--space-small);
    top: var(--space-smaller);
    right: var(--space-slab);
    background-color: var(--s-500);
    border-radius: var(--border-radius-rounded);
  }
}
</style>